module.exports = __webpack_public_path__ + "static/media/INTJ.c0fd09e8.png";